import type { Origin } from "./content.js";

/**
 * Woher der Lehrgang kommt, in einem Satz.
 *
 * Die App wusste das schon immer und hat es weggeworfen. Ohne diese Zeile ist
 * „alter Text, weil Gastmodus“ nicht von „alter Text, weil der Download
 * fehlschlug“ zu unterscheiden – beides sieht gleich aus, und beides ist im
 * Klassenzimmer eine andere Aufgabe.
 *
 * Der Rückfall bleibt stumm im Sinne von „hält die Stunde nicht an“. Stumm heißt
 * aber nicht unauffindbar: der Grund steht im Zustand, und er gehört auf den
 * Schirm, wo eine Lehrkraft ihn sehen kann.
 */
export function originLabel(origin: Origin): string {
  switch (origin.kind) {
    case "builtin":
      return "Gastmodus – eingebauter Lehrgang";
    case "cache":
    case "fetched":
      return `Fassung ${origin.version}`;
    case "fallback":
      return `Eingebauter Lehrgang – ${origin.reason}`;
  }
}

/** Nur der Rückfall ist ein Hinweis; alles andere ist der Normalfall. */
export function originIsFallback(origin: Origin): boolean {
  return origin.kind === "fallback";
}
